import { IApplicationState } from '../../types/redux';

export function getGaGeoLabel(state: IApplicationState): string {
  const {
    newbuilding: { gaGeoLabel },
  } = state;

  return gaGeoLabel;
}
